import Model from 'mixins/model';
import CoverDayModel from 'models/CoverDayModel';
import Moment from 'moment';
import { find, concat } from 'lodash';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

export class CoverCalendarModel extends Model {
    constructor() {
        super();
        this.set('days', []);
        this.set('currentDay', moment().format('YYYY-MM-DD'));
        this.set('downloadingRange', 40);
        this.firstLoad = true;
    }
    setCurrentDay(currentDay) {
        const days = this.get('days');
        const previousDay = this.get('currentDay');
        const currentDayModel = find(days, (o) => o.get('day') === currentDay);
        const previousDayModel = find(days, (o) => o.get('day') === previousDay);
        this.set('currentDay', currentDay);
        previousDayModel.fireEvent('changed');
        currentDayModel.fireEvent('changed');
        this.fireEvent('changedDay');
    }
    getCurrentDay() {
        return find(this.get('days'),
          (dayModel) => dayModel.get('day') === this.get('currentDay'));
    }
    addDays(covers) {
        const lastDay = moment(this.get('lastDay'))
          .subtract(this.get('downloadingRange'), 'days')
          .format('YYYY-MM-DD');
        const firstDay = moment(this.get('lastDay'))
          .subtract(1, 'days')
          .format('YYYY-MM-DD');

        const range = moment.range(lastDay, firstDay);
        const days = this.get('days');
        const newDays = [];

        for (const day of range.by('days')) {
            const date = day.format('YYYY-MM-DD');
            const model = new CoverDayModel();
            model.set('day', date);
            covers.forEach((cover) => {
              if (cover.day === date) {
                model.set('count', cover.count);
              }
            });
            newDays.push(model);
        };

        this.set('lastDay', lastDay);
        this.set('days', concat(newDays, days));
        this.fireEvent('bulked');
    }
    fromJSON(data) {
        const range = moment.range(data.range.start, data.range.end);
        const days = [];
        const covers = data.covers;

        for (const day of range.by('days')) {
            const date = day.format('YYYY-MM-DD');
            const model = new CoverDayModel();
            model.set('day', date);
            covers.forEach((cover) => {
              if (cover.day === date) {
                model.set('count', cover.count);
              }
            });
            days.push(model);
        };

        // The oldest day in collecion is first day in range
        this.set('lastDay', data.range.start);

        const getCurrentDay = () => {
          // if (this.firstLoad) {
          //   this.firstLoad = false;
          //   return
          // } else {
            return (covers.length)
              ? covers[covers.length - 1].day
              : moment().format('YYYY-MM-DD');
          // }
        };

        this.set('currentDay', getCurrentDay());
        this.set('days', days);
    }
}

export const coverCalendarModel = new CoverCalendarModel();



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/models/CoverCalendarModel.js